import { Theme } from '@emotion/react';
import { SxProps } from '@mui/material';
import { Colors } from 'copyright-clearance-center-common-ui';
import { CSSProperties } from 'react';

export const muiTableHeadCellPropsStyle: SxProps<Theme> = {
	borderRight: `1px solid ${Colors.neutral100}`,
	borderBottom: `1px solid ${Colors.neutral100}`,
	paddingBottom: '0.4rem'
};

export const muiTableBodyCellPropsStyle: SxProps<Theme> = {
	fontWeight: 400,
	fontSize: '0.875rem',
	color: Colors.neutral700,
	borderRight: `1px solid ${Colors.neutral100}`,
	borderBottom: `1px solid ${Colors.neutral100}`
};

export const muiTableHeadRowPropsStyle: SxProps<Theme> = {
	backgroundColor: Colors.neutral200,
	color: Colors.neutral700,
	textTransform: 'uppercase',
	fontSize: '0.75rem',
	fontWeight: 500,
	'& .MuiDivider-root': {
		borderColor: 'transparent'
	},
	'& .Mui-TableHeadCell-ResizeHandle-Wrapper': {
		'&:active hr': { borderColor: Colors.primary500 },
		right: 0,
		marginRight: '-0.59rem' // to avoid horizontal scroll when we don't need it.
	},
	'& .Mui-TableHeadCell-Content-Wrapper': {
		textWrap: 'nowrap'
	},
	'& .MuiTableSortLabel-root': {
		marginLeft: '0.25rem'
	}
};

export const muiTableBodyRowPropsStyle: SxProps<Theme> = {
	'&:hover': {
		cursor: 'pointer'
	},
	'&:not(.Mui-selected):hover td:after': {
		backgroundColor: `${Colors.neutral50}`
	},
	'&.Mui-selected td:after, &.Mui-selected:hover': { backgroundColor: `${Colors.primary50}` }
};

export const muiTableContainerPropsStyle: SxProps<Theme> = {
	flex: 1,
	'& .MuiTypography-root': { maxWidth: '100%' }
};

export const muiTablePaperPropsStyle: SxProps<Theme> = {
	height: '100%',
	display: 'flex',
	flexDirection: 'column',
	borderRadius: 0
};

export const libraryResultsRootStyle: CSSProperties = {
	overflow: 'auto',
	flex: '1 1 0%',
	height: '100%',
	display: 'flex',
	flexDirection: 'column'
};

export const LibraryResultsGridStyle: CSSProperties = {
	overflow: 'auto',
	flex: '1 1 0%'
};

export const LibraryResultsGridPaginationStyle: CSSProperties = {
	minHeight: '2.5rem',
	background: '#ffffff',
	borderTop: `1px solid ${Colors.neutral200}`
};

export const UnsetWhiteSpaceForCell: SxProps<Theme> = {
	whiteSpace: 'unset',
	borderRight: `1px solid ${Colors.neutral100}`,
	borderBottom: `1px solid ${Colors.neutral100}`
};
